import React from 'react';

const GoogleGIcon: React.FC<{ size?: number }> = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615Z"
      fill="#4285F4"
    />
    <path
      d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18Z"
      fill="#34A853"
    />
    <path
      d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332Z"
      fill="#FBBC05"
    />
    <path
      d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58Z"
      fill="#EA4335"
    />
  </svg>
);

export interface GoogleReviewConnectCardProps {
  title: string;
  description: string;
  buttonLabel: string;
  loadingLabel: string;
  onConnect: () => void;
  isConnecting: boolean;
  /** Disables the connect button (e.g. subuser without google_review_write). */
  disabled?: boolean;
  /** Tooltip shown on the disabled button. */
  disabledTitle?: string;
  className?: string;
  role?: 'alert';
}

const GoogleReviewConnectCard: React.FC<GoogleReviewConnectCardProps> = ({
  title,
  description,
  buttonLabel,
  loadingLabel,
  onConnect,
  isConnecting,
  disabled = false,
  disabledTitle,
  className,
  role,
}) => {
  const rootClassName = ['google-review-connect-card', className].filter(Boolean).join(' ');

  return (
    <div className={rootClassName} role={role}>
      <div className="google-review-connect-card__inner">
        <div className="google-review-connect-card__icon-box" aria-hidden="true">
          <GoogleGIcon size={32} />
        </div>

        <h2 className="google-review-connect-card__title">{title}</h2>

        <p className="google-review-connect-card__description">{description}</p>

        <button
          type="button"
          className="google-review-connect-card__btn"
          onClick={onConnect}
          disabled={isConnecting || disabled}
          title={disabled ? disabledTitle : undefined}
        >
          <GoogleGIcon />
          {isConnecting ? loadingLabel : buttonLabel}
        </button>
      </div>
    </div>
  );
};

export default GoogleReviewConnectCard;
